import { useState, useContext } from 'react';
import get from 'lodash.get';
import set from 'lodash.set';
import cloneDeep from 'lodash.clonedeep';
import { FormContext } from '.';

const counterMap = {};

const unique = (ns) => {
  counterMap[ns] = counterMap[ns] ? counterMap[ns] + 1 : 1;
  return counterMap[ns];
};

const useRepeatedSection = (namespace, defaults) => {
  const clonedDefaults = cloneDeep(defaults);
  if (typeof namespace !== 'string') throw new TypeError('Form array should be given a namespace (string)');

  const [sectionIDs, setSectionIDs] = useState(() => {
    const preexistingCount = get(defaults, namespace)?.length || 1;
    counterMap[namespace] = preexistingCount;
    return [...new Array(preexistingCount)].map((_, idx) => idx);
  });

  const { removeFieldMatch } = useContext(FormContext);

  const addSection = () => {
    const nextSectionIDs = [...sectionIDs, unique(namespace)];
    return setSectionIDs(nextSectionIDs);
  };

  const removeSectionID = (idToRemove) => {
    const space = `${namespace}[${idToRemove}]`;
    removeFieldMatch(space);
    // clear out the default since it has been removed
    set(clonedDefaults, space, null);
    setSectionIDs(sectionIDs.filter((id) => id !== idToRemove));
  };

  const sections = sectionIDs.map((key) => {
    const buildPath = (next) => `${namespace}[${key}].${next}`;

    return {
      key,
      makeName: (seed) => buildPath(seed),
      getDefault: (seed) => get(clonedDefaults, buildPath(seed)),
      removeSection: () => removeSectionID(key),
      useNested: (ns) => useRepeatedSection(buildPath(ns), clonedDefaults),
    };
  });

  return {
    sections,
    addSection,
  };
};

export default useRepeatedSection;
